import {
  getColorScheme
} from "./chunk-C6ESTM3N.mjs";
import {
  useSmallScreen
} from "./chunk-ALXBK6NV.mjs";

// src/internal/components/header/header-wider.tsx
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { getValidChildren } from "@clara/react-utils";
import { CloseButton, Flex, Logo } from "@clara/ui";
import { jsx, jsxs } from "react/jsx-runtime";
function HeaderWider(props) {
  const { children } = props;
  const sm = useSmallScreen();
  const variants = [
    "account",
    "actions",
    "navigation",
    "title",
    "tools",
    "banner"
  ];
  const { tools, title } = getValidChildren(children).filter((child) => {
    var _a;
    return ((_a = child.type) == null ? void 0 : _a.id) === "HeaderElement";
  }).reduce((acc, child) => {
    var _a;
    const variant = (_a = child == null ? void 0 : child.props) == null ? void 0 : _a.variant;
    const match = variants.includes(child.props.variant);
    return {
      ...acc,
      ...match && { [variant]: child }
    };
  }, {});
  return /* @__PURE__ */ jsx(
    Flex,
    {
      sx: (theme) => ({
        minHeight: theme.spacing(7),
        ...getColorScheme(theme)
      }),
      children: /* @__PURE__ */ jsxs(Flex, { grow: 1, alignItems: "center", py: 1, px: 3, justify: "space-between", children: [
        /* @__PURE__ */ jsxs(
          Stack,
          {
            direction: "row",
            spacing: 1,
            sx: (theme) => ({
              alignItems: "center",
              minWidth: theme.spacing(29)
            }),
            children: [
              /* @__PURE__ */ jsx(
                Logo,
                {
                  href: "/",
                  icon: "monogram",
                  sx: (theme) => ({
                    width: theme.spacing(3),
                    height: theme.spacing(3)
                  })
                }
              ),
              /* @__PURE__ */ jsx(Typography, { variant: "subtitle1", fontWeight: 600, children: title })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          Stack,
          {
            direction: "row",
            spacing: 0.5,
            divider: /* @__PURE__ */ jsx(Divider, { flexItem: true, orientation: "vertical" }),
            alignItems: "center",
            children: [
              !sm && tools,
              /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(CloseButton, { onClick: () => {
                var _a;
                return (_a = props.onClose) == null ? void 0 : _a.call(props);
              } }) })
            ]
          }
        )
      ] })
    }
  );
}

export {
  HeaderWider
};
